<template>
  <div id="image-product">
    <TitleComponent />
    <div class="card mt-3">
      <div class="card-body">
        <div class="mt-2">
          <div class="d-flex align-items-end">
            <div class="ms-1 me-1">
              <label for="selectsearch">Cari by</label>
              <select
                class="form-select"
                aria-label="Default select example"
                id="selectsearch"
                placeholder="Level"
                v-model="search.type"
              >
                <option value="0">-- Pilih --</option>
                <option value="1">Barcode</option>
                <option value="2">Nama</option>
              </select>
            </div>
            <div class="ms-1 me-1">
              <label for="inputsearch">Cari</label>
              <input
                type="email"
                class="form-control"
                id="inputsearch"
                placeholder="Cari produk disini"
                v-model="search.search"
                @keyup.enter="searchIdemp"
              />
            </div>
            <div class="ms-1 me-1">
              <button class="btn btn-primary btn-sm" @click="searchIdemp">
                <i class="fas fa-search"></i>
              </button>
            </div>
            <div class="ms-1 me-1">
              <button class="btn btn-secondary btn-sm" @click="reloadPage">
                <i class="fas fa-sync-alt"></i>
              </button>
            </div>
          </div>
          <div class="table-responsive-sm table-responsive-md mt-2" style="height: 400px; overflow: auto;">
            <div class="table-wrapper">
              <table class="table table-sm table-hover table-bordered">
                <thead>
                  <tr class="text-center">
                    <th width="10">No</th>
                    <th width="50">Gambar</th>
                    <th width="20">Barcode</th>
                    <th width="100">Deskripsi</th>
                    <th width="10">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(n, i) in datasAdd" :key="i">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td class="text-center">
                      <img
                        :src="n.imageurl || require('../assets/image/noimage.png')"
                        @error="event => event.target.src = require('../assets/image/noimage.png')"
                        alt="Image Preview"
                        class="img img-fluid"
                        loading="lazy"
                        style="width: 80px; height: 80px"
                      />
                    </td>
                    <td class="text-center">{{ n.mixcode }}</td>
                    <td>{{ n.descripiton }}</td>
                    <td class="text-center">
                      <!-- <button class="btn btn-warning btn-sm me-1">
                            <i class="fas fa-eye"></i>
                          </button> -->
                      <button
                        class="btn btn-warning btn-sm ms-1"
                        data-bs-toggle="modal"
                        data-bs-target="#uploadImageModal"
                        @click="$store.commit('ImageProduct/SET_DETAIL_ADD', n)"
                      >
                        <i class="fas fa-upload"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <AddProductModalComponent /> -->
    <uploadImageComponanet />
  </div>
</template>
<script>
// import AddProductModalComponent from "@/components/images/addProductModalComponent.vue";
import uploadImageComponanet from "@/components/images/uploadImageComponent.vue";
import TitleComponent from "@/components/TitleComponent.vue";

export default {
  components: {
    TitleComponent,
    // AddProductModalComponent,
    uploadImageComponanet,
  },
  data() {
    return {};
  },
  computed: {
    datasAdd() {
      return this.$store.state.ImageProduct.datasAdd;
    },
    search: {
      get() {
        return this.$store.state.ImageProduct.searchAdd;
      },
      set(value) {
        this.$store.commit("ImageProduct/SET_SEARCH_ADD", value);
      },
    },
  },
  methods: {
    searchIdemp() {
      this.$store.dispatch("ImageProduct/searchIdemp");
    },
    reloadPage() {
      window.location.reload();
    },
  },
  created() {
    this.$store.commit("ImageProduct/RESET_FORMADD");
  },
};
</script>
<style scoped>
.box-image {
  position: relative;
  object-fit: cover !important;
  position: relative !important;
  border: 1px solid rgba(59, 58, 58, 0.1);
  box-shadow: 4px 4px 16px rgba(92, 92, 92, 0.1);
  border-radius: 8px;
  padding: 5px;
  width: 100%;
  height: 350px;
}

@media (max-width: 576px) {
  .box-image {
    height: 100%;
  }
}

.box-image:hover {
  border: 1px solid rgba(20, 79, 216, 0.3);
  box-shadow: 4px 4px 16px rgba(20, 79, 216, 0.3);
  transition: all 0.3s ease;
}
.box-image .img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  border-radius: 8px;
}

.box-upload {
  background-color: #e8e8e8;
  box-shadow: 4px 4px 16px rgba(92, 92, 92, 0.1);
  width: 100%;
  height: 350px;
}

.file-box {
  border: 2px dashed #ccc;
  padding: 5px;
  border-radius: 8px;
  text-align: center;
  background-color: #fff;
  height: 100% !important;
  transition: border-color 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.file-box p {
  margin: 10px 0;
  font-size: 14px;
  color: #555;
}

.file-box:hover {
  border-color: #007bff;
}

.file-btn {
  display: inline-block;
  padding: 8px 15px;
  background-color: #007bff;
  color: #fff !important;
  font-size: 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}

.file-btn:hover {
  background-color: #0056b3;
}
</style>
